// extracted by mini-css-extract-plugin
export default {"eventDateContainer":"lOkCXjO87g4ZT48QRXQi","calendarIcon":"ibKCXWdBXXcJqDqAn6Mu"};